import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'concrete-pouring-and-pumping-sydney';
const serviceId = 3
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Concrete Pouring & Pumping Sydney | ${BUSINESS_NAME}`,
        description: "Efficient and reliable concrete pumping and placement services.",
        keywords: "concrete pumping Sydney, concrete pouring services, commercial concrete pumping, residential concrete pumping, industrial concrete pumping, concrete placement, boom pump services, line pump services, high-rise concrete pumping, foundation concrete pumping, slab concrete pouring, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Concrete Pouring & Pumping',
    description: 'Efficient and reliable concrete pumping and placement services.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
